import { fetchWithAuth } from "../utils/authFetch";

/** GET full decrypted outreach state for the signed-in user. */
export async function getOutreachState() {
  const res = await fetchWithAuth("/api/me/outreach-state");
  if (!res.ok) {
    throw new Error(`outreach-state GET ${res.status}`);
  }
  return res.json();
}

/** PATCH any of { saved, drafts, templates, todos }. Server merges at the top
 * level — omitted fields are preserved. Pass the FULL replacement value for any
 * sub-map you want to write (the server replaces, it does not merge keys).
 * Pipeline status is NOT here; see candidateStateService. */
export async function patchOutreachState(patch) {
  const res = await fetchWithAuth("/api/me/outreach-state", {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch || {}),
  });
  if (!res.ok) {
    throw new Error(`outreach-state PATCH ${res.status}`);
  }
  return res.json();
}
